import React, { memo } from 'react';
import {
  FormPageInputItemNumberAdditionalText,
  NumberAdditionalTextInput,
  NumberPropertyAdditionalText,
} from 'shared';
import { FormFieldInputItemProps } from '../shared';

type NumberValue = FormPageInputItemNumberAdditionalText['number'];

type Props = FormFieldInputItemProps<
  NumberPropertyAdditionalText,
  FormPageInputItemNumberAdditionalText
> & {
  value: NumberValue;
};

const NUMBER_KEY: Extract<
  keyof FormPageInputItemNumberAdditionalText,
  'number'
> = 'number';

export const NumberAdditionalText: React.FC<Props> = memo(
  ({
    property,
    disabled,
    design,
    value,
    onChange,
    onBlur,
    className,
    errorMessages,
    displayError,
  }) => {
    const { propertyId, inputFormat } = property;
    const { before, after, placeholder, width } = inputFormat;
    const handleChange = (numberValue: NumberValue) => {
      onChange(NUMBER_KEY, numberValue);
    };
    const handleBlur = (numberValue: NumberValue) => {
      onBlur(NUMBER_KEY, numberValue);
    };
    return (
      <NumberAdditionalTextInput
        propertyId={propertyId}
        placeholder={placeholder}
        before={before}
        after={after}
        value={value}
        disabled={disabled}
        displayError={displayError}
        errorMessages={errorMessages}
        onChange={handleChange}
        onBlur={handleBlur}
        design={design}
        className={className}
        width={width.value}
      />
    );
  },
);
